module.exports = __webpack_public_path__ + "img/samson.1b7ed8c6.png";